<template>
  <div class="modal show fade modal-primary text-left" style="display: block;" v-if="show">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel120">Api Keys</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-8">
              <div class="form-group">
                <label>Client ID</label>
                <input
                    class="form-control"
                    type="text"
                    v-model="clientId"
                    disabled
                >
              </div>
            </div>
            <div class="col-2">
              <label></label>
              <div class="form-group">
                <div class="badge badge-glow badge-pill badge-primary btn mt-1" @click="copyText(clientId)"><BIconJournalText  class="" /> Copy!</div>
              </div>
            </div>
            <div class="col-8">
              <div class="form-group">
                <label>Client Secret</label>
                <input
                    class="form-control"
                    type="text"
                    v-model="clientSecret"
                    disabled
                >
              </div>
            </div>
            <div class="col-2">
              <label></label>
              <div class="form-group">
                <div class="form-group">
                  <div class="badge badge-glow badge-pill badge-primary btn mt-1" @click="copyText(clientSecret)"><BIconJournalText class="" /> Copy!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        <div class="modal-footer justify-content-between">-->
<!--          <button type="button" class="btn btn-gradient-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>-->
<!--        </div>-->
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>

export default {
  props: ['show'],
  data() {
    return {
      list: [],
      clientSecret: '',
      clientId:'',
    }
  },
  mounted() {

  },
  methods: {
    getMerchantAppSettings() {

      this.makeRequest('post', 'v1/get-merchant-app-settings', {},{},false).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if(typeof(data[0]) != 'undefined'){
              this.clientId = data[0].client_id
              this.clientSecret = data[0].client_secret
            }
          }
        }

      });

    },
  },
  watch:{
    show(val){
      if(val){
        this.getMerchantAppSettings()
      }
    }
  }
}
</script>



